module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAABMUlEQVRoQ+2a6RHCIBBGdzuxBEuwE61ibUFownSidmAJWgkOGZOJmgPMwX4Z8pvjPRbCQsLWWkfAD2eBxNHLEUgcAFpFBK6pR3FM/zymsoa6WSB1FP6KgLX2ICJFanjff7SAMaZg5o2I7OAE3vB7IrrBCTTg/cBjCXzBYwm0wOMIdMBjCPTA6xcYgNctEACvVyAQ3gs8mFnXThwBr2EDrhnKVAIVvsyFkOFLAZ9ZEtFZ1byIgCmnELJEnU6jSnycB4wxJ2Y+BkTw6ZzT9RqtoAMjoTudDpDQLRCwsPULDEhgCPRI4Ah0SGAJtEjgCXxJYAo0JPzNHN7FVmOz24rIPWDHnr1I9NXi7ESRHWSByAGbvLg/0Fwmb3XBBlfxkS//arDgjPnpKk+hlKNfXatAr4EXQiafMaZo0aEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/缩回菜单-01.png
// module id = kBn5
// module chunks = 0